import { Divider, Stack, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { PageHeader } from "#/features/global-ui/page-header"
import { PageLayout } from "#/features/global-ui/page-layout"
import { CarrotCompanionDetails } from "./CarrotCompanionDetails"
import { MainCard } from "./MainCard"
import { PastAppointments } from "./PastAppointments"
import { SidebarCard } from "./SidebarCard"
import { UpNext } from "./UpNext"

export function ConsumerAppointmentsPage(): JSX.Element {
  const pageTitle = "Appointments"
  const theme = useTheme()

  // Todo: add conditional rendering for various elements on this page
  return (
    <PageLayout variant="sidebar" header={<PageHeader pageTitle={pageTitle} />} sidebar={<SidebarCard />}>
      <Stack sx={{ flexDirection: "column" }} spacing={theme.spacing(theme.tokens.spacing.xl)}>
        <UpNext />
        <PastAppointments />
        <MainCard />
        <Divider />
        <CarrotCompanionDetails />
      </Stack>
    </PageLayout>
  )
}
